export default "__VITE_ASSET__k8X2bFHF__"